export const MAP_COLORS = {
  background: '#2c3e50',
  land: '#1a1a1a',
  water: '#ff0000',
  gold: '#d4af37',
  goldLight: '#ffcc00',
  glass: '#d4af37',
  fog: '#121212',
  light: '#ffd700',
}

const DEFAULT_MAP_STYLE_URL = 'https://map.loi-masters.com/style.json'

export const MAP_CONFIG = {
  style: process.env.REACT_APP_MAP_STYLE_URL || DEFAULT_MAP_STYLE_URL,
  defaultCenter: {lng: 37.61, lat: 55.75},
  defaultZoom: 2,
  minZoom: 2,
  maxZoom: 20,
  hash: true,
  antialias: true,
  maplibreLogo: false,
}
